const ecpRoutes = [
  {
    path: "/ecp",
    name: "",
    meta: {
      title: "프로그램",
      isDynamic: true,
    },
    children: [
      /** 프로그램 신청 */
      {
        path: "reg", // /ecp/reg
        name: "ecpRegIndex",
        meta: {
          title: "프로그램 등록",
          titleEn: "Extracurricular Activities Registration",
          menuCd: "STAFF_ECP_REG",
        },
        component: () => import("@/views/staff/ecp/reg/EcpRegIndex.vue"),
      },
      {
        path: "reg/detail", // /ecp/reg/detail
        name: "ecpRegDetail",
        meta: {
          title: "프로그램 등록 상세",
          titleEn: "Extracurricular Activities Registration Detail",
          menuCd: "STAFF_ECP_REG",
        },
        component: () => import("@/views/staff/ecp/reg/EcpRegDetail.vue"),
      },
      /** 프로그램 운영 */
      {
        path: "oper", // /ecp/oper
        name: "ecpOperIndex",
        meta: {
          title: "프로그램 운영",
          menuCd: "STAFF_ECP_OPER",
        },
        component: () => import("@/views/staff/ecp/oper/EcpOperIndex.vue"),
      },
      {
        path: "setting", // /ecp/oper/setting
        name: "ecpSetting",
        meta: {
          title: "프로그램 설정",
          titleEn: "Extracurricular Activities Setting",
          menuCd: "STAFF_ECP_OPER",
        },
        component: () => import("@/views/staff/ecp/oper/EcpSetting.vue"),
      },
      /** 프로그램 신청 */
      {
        path: "staff-apply", // /ecp/staff-apply
        name: "ecpApplyIndex",
        meta: {
          title: "프로그램 신청",
          titleEn: "Extracurricular Activities Apply",
          menuCd: "STAFF_ECP_APPLY",
          isDynamic: true,
        },
        component: () => import("@/views/staff/ecp/apply/StaffEcpApplyIndex.vue"),
      },
      /** 프로그램 상세 */
      {
        path: "detail/:ecpId", // /ecp/detail/:ecpId
        name: "ecpDetail",
        meta: {
          title: "프로그램 신청 상세",
          mobileHd: true,
          mobileTitle: "프로그램 신청",
          titleEn: "Extracurricular Activities Apply Detail",
          menuCd: "STAFF_ECP_APPLY",
          isDynamic: false,
          likeBtn: true,
          site: "inha",
        },
        //@gqf
        component: () => import("@/views/student/ecp/apply/EcpDetail.vue"),
      },
      /* 나의 프로그램 */
      {
        path: "staff-my-ecp",
        name: "myEcp",
        children: [
          {
            path: "", // /ecp/staff-my-ecp
            name: "myEcpIndex",
            meta: {
              title: "나의 프로그램",
              titleEn: "My Extracurricular Activities",
              menuCd: "STAFF_MY_ECP",
              isDynamic: true,
            },
            component: () => import("@/views/student/ecp/my-ecp/MyEcpIndex.vue"),
          },
          /* 3-2. 강의실 */
          {
            path: "classroom", // /ecp/staff-my-ecp/classroom
            name: "myEcpClassroom",
            meta: {
              title: "강의실",
              titleEn: "Classroom",
              menuCd: "STAFF_MY_ECP",
              isDynamic: true,
            },
            component: () => import("@/views/student/ecp/my-ecp/MyEcpClassroomIndex.vue"),
          },
        ],
      },
      /* 부서 CQI */
      {
        path: "cqi-dept",
        name: "CQI Department",
        children: [
          {
            path: "", // /ecp/cqi-dept
            name: "cqiDept",
            meta: {
              title: "부서 CQI",
              titleEn: "CQI Department",
              menuCd: "STAFF_CQI_DEPT",
              isDynamic: true,
            },
            component: () => import("@/views/staff/ecp/cqi/dept/CqiDeptList.vue"),
          },
          {
            path: "register", // ecp/cqi-dept/register
            meta: {
              title: "부서CQI 등록",
              titleEn: "Register CQI Department",
              isDynamic: true,
              menuCd: "STAFF_CQI_DEPT",
            },
            component: () => import("@/views/staff/ecp/cqi/dept/RegCqiDept.vue"),
          },
        ],
      },
      /* 대학CQI */
      {
        path: "cqi-univ",
        name: "CQI University",
        children: [
          {
            path: "answer", // ecp/cqi-univ/answer
            meta: {
              title: "대학CQI 답변",
              titleEn: "Answer CQI University",
              isDynamic: true,
              menuCd: "STAFF_CQI_UNIV",
            },
            component: () => import("@/views/staff/ecp/cqi/univ/AnsCqiUnivList.vue"),
          },
          {
            path: "answer-register", // ecp/cqi-univ/answer/register
            meta: {
              title: "대학CQI답변등록",
              titleEn: "Register Answer CQI University",
              isDynamic: true,
              menuCd: "STAFF_CQI_UNIV",
            },
            component: () => import("@/views/staff/ecp/cqi/univ/RegAnsCqiUniv.vue"),
          },
        ],
      },
    ],
  },
];
export default ecpRoutes;
